import React, { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useDispatch } from "react-redux";
import ConfirmModal from "../../../components/modal/ConfirmModal/ConfirmModal";
import { tt } from "../../../utils/i18n/i18n";
import { JetpackConfigAPI } from "../api/JetpackConfigAPI";
import { updateCustomerThunk } from "../../../redux/actions/user";
import fetchAllManagedAccounts from "../../../api/fetchAllManagedAccounts";

interface FreeTrialModalProps {
  initialPhoneNumber: string;
  token: string;
  trackingID: string;
  description?: string;
  customTitle?: string;
  customMessage?: string;
}

const FreeTrialModal = NiceModal.create<FreeTrialModalProps>((props) => {
  const modal = useModal();
  const dispatch = useDispatch();
  const [phoneNumber, setPhoneNumber] = useState(props.initialPhoneNumber);
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);

    try {
      await dispatch(
        updateCustomerThunk(
          { contactPhoneNumber: phoneNumber },
          props.trackingID,
          props.token
        )
      );
      await JetpackConfigAPI.requestFreeTrial(props.token, props.description);
      await dispatch(fetchAllManagedAccounts({}));
      modal.resolve(true);
      void modal.hide();
    } catch (error) {
      console.error(error);
      modal.resolve(false);
      void modal.hide();
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    modal.resolve(false);
    void modal.hide();
  };

  return (
    <ConfirmModal
      {...modal}
      title={props.customTitle ?? tt("free_trial_confirm_title")}
      confirmLabel={tt("free_trial_confirm_button")}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      noHideOnConfirm={true}
    >
      <p>{props.customMessage ?? tt("free_trial_confirm_message")}</p>
      <br />
      <p>{tt("free_trial_confirm_phone_prompt")}</p>
      <input
        id="phone"
        className="form-control mt-1"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        disabled={isLoading}
      />
    </ConfirmModal>
  );
});

export default FreeTrialModal;
